import { createApp } from 'vue';

import {iconMdi} from '@/Icons';
import App from './App.vue';

const app = createApp(App).component('icon-mdi', iconMdi);

app.mount('#app');
